import type React from 'react';
import { EMPTY_ARRAY, useTenderDetails } from '../../contexts/TenderDetailsContext';
import DraftActionCard from './ActionCards/DraftActionCard';
import WorkflowStep from './WorkflowStep';

const DraftGenerationStep: React.FC = () => {
  const {
    canManageTender,
    openStep,
    setOpenStep,
    tender,
    quickSettings,
    user_docs,
    sectionsCount,
    loadingStates,
    stepCompletion,
    handleRegenerate,
    handleDownload,
    handleResetTender,
    handleUpdateServiceStatus,
    handleNavigateToDownload,
    handleQuickSettingsChange,
  } = useTenderDetails();

  if (!canManageTender) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={8}
      expanded={openStep === 8}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 8 : null)}
      title={
        (tender?.detectedForms || EMPTY_ARRAY).length > 0
          ? 'Draft Generation (Forms Detected)'
          : 'Draft Generation'
      }
      description={
        (tender?.detectedForms || EMPTY_ARRAY).length > 0
          ? 'Generate a narrative draft. Forms will be completed in Step 12.'
          : 'Generate a narrative draft bid/proposal.'
      }
      isComplete={
        !!tender.draftFileLink ||
        tender.draftResponse?.status === 'Sections Generated' ||
        tender.draftResponse?.status?.toLowerCase() === 'complete' ||
        sectionsCount > 0
      }
    >
      <DraftActionCard
        tender={tender}
        quickSettings={quickSettings}
        userDocsCount={user_docs.length}
        sectionsCount={sectionsCount}
        loadingStates={loadingStates}
        stepCompletion={stepCompletion}
        onRegenerate={handleRegenerate}
        onDownload={handleDownload}
        onReset={() => handleResetTender('response')}
        onUpdateStatus={handleUpdateServiceStatus}
        onNavigateToDownload={handleNavigateToDownload}
        onQuickSettingsChange={handleQuickSettingsChange}
      />
    </WorkflowStep>
  );
};

export default DraftGenerationStep;
